<script>
import {mapState} from "vuex";
import i18n from "@/i18n";
import AddressEdit from "@/components/ClientPicker/AddressEdit.vue";

export default {
  components: {
    AddressEdit
  },
  props: {
    status: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      modalRefName: "ModalEditAddress"
    };
  },
  computed: {
    ...mapState({
      appId: state => state.app.id,
      token: state => state.app.token,
      loadingContact: state => state.contacts.loadingContact,
      isThirdAccountGlobal: state => state.contacts.isThirdAccountGlobal
    })
  },
  mounted() {
  },
  methods: {
    closed() {
      this.$store.commit('showEditAddressModal', false)
      this.$store.commit("renderGA", false);
      this.$store.commit('resetEditableContact');
      this.$store.commit('resetEditableEstablishment');
    },
    saveAddress() {
      this.$store.dispatch("updateOrCreateEstablishmentPlaceFromEditableEstablishment", { target: this.isThirdAccountGlobal ? "thirdAccount" : "contactInfos" });
    },
    opened() {
      this.$store.commit("renderGA", true);
    }
  }
};
</script>

<template>
  <b-modal
      :ref="modalRefName"
      :visible="status"
      :ok-only="true"
      centered
      header-class="bg-modal-contact"
      :footer-class="{'bg-modal-contact': true}"
      size="sm"
      @close="closed"
      content-class="shadow"
      @hide="closed"
      @shown="opened"
  >
    <template #modal-header>
      <!-- Emulate built in modal header close button action -->
      <b-container style="max-width: 660px">
        <b-row>
          <b-col cols="11" class="pl-0">
            <b-container class="p-0">
              <b-row class="p-0">
                <b-col cols="1" style="margin-top: -0.1rem"><span class="d-none d-sm-block" style="font-size: 1rem"><b-icon icon="map" /></span></b-col>
                <b-col cols="11" class="pl-lg-0"><h5>{{ $t('Adresse postale') }}</h5></b-col>
              </b-row>
            </b-container>
          </b-col>
          <b-col cols="1 text-right pr-0">
            <div class="close_icon icon_square text-center" @click="closed">
              <b-icon icon="x" font-scale="0.9" class="px-0" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>

    <template #modal-footer>
      <!-- Emulate built in modal header close button action -->
      <b-container>
        <b-row>
          <b-col class="text-right">
            <s-button
              type="border"
              style="width: auto"
              @click="closed"
            >
              {{ $t("Annuler") }}
            </s-button>
            <s-button
              type="success"
              style="width: auto"
              class="ml-2"
              :loading="loadingContact"
              :disabled="loadingContact"
              @click="saveAddress"
            >
              {{ $t("Enregistrer") }}
            </s-button>
          </b-col>
        </b-row>
      </b-container>
    </template>

    <AddressEdit map-id="editOrganization" ref="editAddress" />
  </b-modal>
</template>

<style scoped>

</style>